import { useMemo } from 'react';

import { useControlStore } from 'store/controls';
import { useCurrentUserStore } from 'store/currentUser';
import type { IUser } from 'store/declare';
import { useUsersStore } from 'store/users';

/** Данные всех участников конференции, включая текущего пользователя */
export function useAllUserList() {
    const { users } = useUsersStore();
    const { currentUser: currentUserStore } = useCurrentUserStore();
    const { controls } = useControlStore();

    const currentUser = useMemo(() => {
        if (currentUserStore) {
            return {
                ...currentUserStore,
                // состояние "Говорит" текущего пользователя с учетом состояния микрофона
                isTalking: !!(controls.mic ? currentUserStore?.isTalking : false),
            } as IUser;
        }

        return null;
    }, [currentUserStore, controls.mic]);

    return useMemo(() => {
        // иногда при обновлении страницы VOX присылает информацию о текущем пользователе как о "другом" собеседнике
        // необходимо фильтровать список пользователей с этой особенностью
        const list = [currentUser, ...users.filter(user => user.id !== currentUser?.id)].filter(Boolean) as IUser[];

        /** Получить пользователя по его boolean свойству */
        function getUserByBooleanProperty(property: Extract<keyof IUser, 'isSharing' | 'isTalking'>) {
            // поиск по свойству "Демонстрация экрана" производим с конца
            // это необходимо для программного отключения демонстрации экрана
            // текущего пользователя, если кто-то другой начал демонстрацию экрана
            // в противном случае - всегда будет возвращаться текущий пользователь
            if (property === 'isSharing') return [...list].reverse().find(user => user[property]);

            return list.find(user => user[property]);
        }

        return {
            list,
            screenShareUser: getUserByBooleanProperty('isSharing'),
        };
    }, [currentUser, users]);
}
